//wp.data.select('core').getEntityRecord('taxonomy', 'product_cat', 28);

// import { store as coreStore } from '@wordpress/core-data';
// import { store as editorStore } from '@wordpress/editor';
//
// const getCurrentPostId = createRegistrySelector(select => state => {
// 	return select(editorStore).getCurrentPostId();
// });
//
// alert(getCurrentPostId);
